import {
  $convertFromMarkdownString,
  MultilineElementTransformer,
  Transformer,
} from '@lexical/markdown';
import { LexicalNode } from 'lexical';
import {
  $createSuggestionNode,
  $isRejectedSuggestion,
  $isSuggestionAccepted,
  $isSuggestionNode,
} from '../../nodes/SuggestionNode';

export const createSuggestionTransformer = (
  transformers: Transformer[],
): MultilineElementTransformer => ({
  type: 'multiline-element',
  dependencies: [],

  regExpStart: /^<suggestion>$/,
  regExpEnd: /^<\/suggestion>$/,

  export: (node: LexicalNode, traverseChildren) => {
    if (!$isSuggestionNode(node)) {
      return null;
    }

    if ($isRejectedSuggestion(node)) {
      return '';
    }

    const output: string[] = [];
    if (!$isSuggestionAccepted(node)) {
      output.push('<suggestion>');
    }
    output.push(traverseChildren(node));
    if (!$isSuggestionAccepted(node)) {
      output.push('</suggestion>');
    }
    return output.join('\n');
  },

  replace: (parentNode, children, startMatch, endMatch, linesInBetween) => {
    if (!startMatch || !endMatch) {
      return;
    }

    const suggestion = $createSuggestionNode();
    if (children) {
      suggestion.append(...children);
    } else if (linesInBetween) {
      $convertFromMarkdownString(linesInBetween.join('\n'), transformers, suggestion);
    }

    parentNode.append(suggestion);

    suggestion.selectNext();
  },
});
